'use strict'

import Axios from 'axios';
import configuration from './../../configuration'
var url = configuration.apiHost;

export default class UserService {

  static validade(person) {
    let errors = []
    if(person.isLegalPerson){
      if (!person.name) errors.push('nome')
      if (!person.email) errors.push('e-mail')
      if (!person.cpf) errors.push('cpf')
      if (!person.rg) errors.push('rg')
    }

    if (errors.length > 0) return errors
    else return null
  }

  static async getAll() {
    try {
      let users = await Axios.get(url + "persons");
      return users.data;
    } catch (error) {
      throw error.response.data;
    }
  } // getAll()
  static async getPersonsForSpecificData(/* Array de parametros? */) {
    try {
      let personsSaved = await Axios.get(`${url}persons/find/ _id name socialName  address`);
      return personsSaved.data;
    } catch (error) { 
      throw error.response.data;
    }
  }

  static async save(person) {
    try {
      let personSaved = await Axios.post(url + "persons", person);
      return personSaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(person) {
    try {
      let personUpdated = await Axios.put(url + "persons", person);
      return personUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(person) {
    try {
      await Axios.delete(url + "persons", {
        data: person
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()

  static async searchCnpj(cnpj) {
    try {
      let validCnpj = await Axios.post(url + "searchCnpj", cnpj);
      return validCnpj.data;
    } catch (error) {
      throw error.response.data;
    }
  } // searchCnpj()
} // class



// WEBPACK FOOTER //
// ./src/service/PersonService.js